import React                             from 'react';
import { Observe, defaultEquals }        from 'rewire-core';
import { ICell }                         from 'rewire-grid';
import { withStyles, Theme }             from 'rewire-ui';
import { isMultiple }                    from '../DataTypes';
import { StyleType }                     from '../utility/styles';

const styles = (theme: Theme) => ({
  differenceValue1: {
    textDecoration: 'line-through',
    color: theme.palette.error.main,
    marginRight: '5px',
  },
  differenceValue2: {
    color: theme.palette.success.light,
  },
  
});

interface ICellProps {
  cell: ICell;
  classes: StyleType<typeof styles>;
}

const DifferenceCellRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(styles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (!cell.value) return null;
    const value            = cell.column.map ? cell.column.map(cell.value) : cell.value;
    const {value1, value2} = value;
    return (
      (isMultiple(cell.value.value1) && isMultiple(cell.value.value2)) || defaultEquals(cell.value.value1, cell.value.value2)
        ? <span>{value1}</span>
        : < >
            <span className={classes.differenceValue1}>{value1}</span>
            <span className={classes.differenceValue2}>{value2}</span>
          </>
    );
  }} />;
}));

export const AuditLogDifferenceCellRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(styles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (!cell.value) return null;
    const value            = cell.column.map ? cell.column.map(cell.value) : cell.value;
    const {value1, value2} = value;
    return (
      (isMultiple(cell.value.value1) && isMultiple(cell.value.value2)) || defaultEquals(cell.value.value1, cell.value.value2)
        ? <span>{value1}</span>
        : <>
            <div className={classes.differenceValue1}>{value1}</div>
            <div className={classes.differenceValue2}>{value2}</div>
          </>
    );
  }} />;
}));

export default DifferenceCellRenderer;
